import React, { useRef } from "react";
import { AdvUplinkTemplate, advUplinkTemplateView, selectedAdvisorySelector } from "@poscon/shared-frontend";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import { processEramMessage } from "~redux/thunks/processEramMessage";
import type { Container as PixiContainer } from "pixi.js";
import { viewPositionSelector } from "~redux/slices/edstSlice";
import { useDragging } from "hooks/useDragging";
import { layerZIndexMap } from "~/layerZIndexMap";
import { useEventMode } from "components/utils/InteractiveContainer";

const view = advUplinkTemplateView;

export const CpdlcAdvUplinkTemplate = () => {
  const dispatch = useRootDispatch();
  const ref = useRef<PixiContainer | null>(null);
  const pos = useRootSelector((state) => viewPositionSelector(state, view));
  const { startDrag } = useDragging(ref, view);
  const adv = useRootSelector(selectedAdvisorySelector);
  const eventMode = useEventMode();

  return adv ? (
    <AdvUplinkTemplate
      ref={ref}
      pos={pos}
      startDrag={startDrag}
      zIndex={layerZIndexMap.prompts}
      eventMode={eventMode}
      adv={adv}
      dispatchCommand={(command) => dispatch(processEramMessage(command))}
    />
  ) : null;
};
